import {baseRequestService} from "../base.ts";

export const eventsEventIdRequestVatsimPost = (eventId: string) => baseRequestService({
    url: `/events/${eventId}/request_vatsim`,
    method: 'POST',
})